export default __webpack_public_path__ + "static/media/018-Cathedral of St Basil.2ce5413b.svg";